// extracted by mini-css-extract-plugin
export default {"container":"DashboardTemplate_container__CHYQ1","tableContainer":"DashboardTemplate_tableContainer__QbUnw","alert":"DashboardTemplate_alert__OL2B+"};